import { render, staticRenderFns } from "./in.vue?vue&type=template&id=3dd2a8fa&scoped=true"
import script from "./in.vue?vue&type=script&lang=js"
export * from "./in.vue?vue&type=script&lang=js"
import style0 from "./in.vue?vue&type=style&index=0&id=3dd2a8fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd2a8fa",
  null
  
)

export default component.exports